@let v = vista();
<figure #figura class="super-ejecutivo-grafica" [class.super-ejecutivo-grafica--ampliada]="anchoParaImagen() !== null"
  [style.width.px]="anchoParaImagen()" [attr.aria-label]="v.titulo">
  <figcaption class="super-ejecutivo-grafica-titulo">{{ v.titulo }}</figcaption>
  <app-super-ejecutivo-descarga class="super-ejecutivo-grafica-descargar" [etiqueta]="etiquetaDescarga"
    [descargando]="descargando()" (imagen)="descargarImagen()" (excel)="descargarExcel()"></app-super-ejecutivo-descarga>

  @switch (v.tipo) {
    @case ('cifras') {
      <div class="super-ejecutivo-grafica-cifras">
        @for (cifra of v.cifras; track $index) {
          <div class="super-ejecutivo-grafica-cifra">
            <span class="super-ejecutivo-grafica-cifra-valor">{{ formatear(cifra.valor, cifra.unidad ?? v.unidad) }}</span>
            <span class="super-ejecutivo-grafica-cifra-etiqueta">{{ cifra.etiqueta }}</span>
            @if (cifra.detalle) {
              <span class="super-ejecutivo-grafica-cifra-detalle">{{ cifra.detalle }}</span>
            }
          </div>
        }
      </div>
    }
    @case ('progreso') {
      <div class="super-ejecutivo-grafica-progreso" role="progressbar" [attr.aria-valuenow]="v.valor" [attr.aria-valuemax]="v.total">
        <div class="super-ejecutivo-grafica-progreso-pista">
          <div class="super-ejecutivo-grafica-progreso-barra" [style.width.%]="anchoProgreso()"
            [class.super-ejecutivo-grafica-progreso-barra--verde]="v.semaforo === 'verde'"
            [class.super-ejecutivo-grafica-progreso-barra--naranja]="v.semaforo === 'naranja'"
            [class.super-ejecutivo-grafica-progreso-barra--rojo]="v.semaforo === 'rojo'"></div>
        </div>
        <div class="super-ejecutivo-grafica-progreso-texto">
          <strong>{{ formatear(v.valor, v.unidad) }}</strong> de {{ formatear(v.total, v.unidad) }} ({{ porcentajeProgreso() }} %)
        </div>
      </div>
    }
    @case ('mapaCalor') {
      <div #mapa class="super-ejecutivo-grafica-mapa-contenedor">
        <table class="super-ejecutivo-grafica-mapa">
          <thead>
            <tr>
              <th></th>
              @for (columna of v.columnas; track $index) {
                <th>{{ columna }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (fila of v.filas; track $index; let i = $index) {
              <tr>
                <th>{{ fila }}</th>
                @for (celda of celdasMapaCalor()[i]; track $index) {
                  <td [style.background]="celda.color">{{ celda.texto }}</td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @default {
      @if (chart(); as c) {
        <div class="super-ejecutivo-grafica-lienzo" [style.height.px]="alto()">
          <canvas baseChart [type]="c.type" [data]="c.data" [options]="c.options" [plugins]="plugins"></canvas>
        </div>
      }
    }
  }

  @if (v.unidad && v.tipo !== 'cifras' && v.tipo !== 'progreso') {
    <div class="super-ejecutivo-grafica-unidad">En {{ v.unidad }}</div>
  }
  @if (v.nota) {
    <div class="super-ejecutivo-grafica-nota">{{ v.nota }}</div>
  }
</figure>
